import * as _4 from 'lodash4';
import { MajorCredentialsQuery } from '../../../src/data/queries/major_credential_query';

export class MajorCredentialsViewContentController {
  constructor(private ngMajorCredentialsQuery: MajorCredentialsQuery) {}

  hasMajorCredentials(): boolean {
    return !_4.isEmpty(this.ngMajorCredentialsQuery.result);
  }
}

export class MajorCredentialsViewContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/components/major_credentials_view_content/major_credentials_view_content.html';
  public controller: any = MajorCredentialsViewContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_credentials_view_content/major_credentials_view_content_controller.ts